import React from "react";
import {
  Col,
  Table,
  Row
} from 'reactstrap';
import TableHeader from '../OpenItemTable/TableHeader';
import TableData from '../OpenItemTable/TableData';
import TableLoader from '../OpenItemTable/TableLoader';
import AkPagination from '../../AkPagination'
import { SearchIcon } from '../../Icon';
import '../OpenItemTable/table.scss';

interface Props {
  data: any | undefined;
  fetching?: boolean;
  type?: string;
  client_code?: any;
  token?: any;
  history?: any;
  count?: number | undefined;
  fetchNewData: Function;
  tableHeader: any;
  handleSearch: (e: any) => void;
  pagination?: any;
  updatePagination: (data: any) => void;
  activeTab?: string;
  handleSendOpenItemEmail?: (id: number) => void;
}

interface State {
  activePage: number;
  // count       : number;
  limit: number;
  pageNumber: number;
  startCount: number;
  endCount: number;
  prev: boolean;
  next: boolean;
}
class SharedOpenItemsTable extends React.Component<Props, State>{
  // state = {
  //     activePage: 1,
  //     limit: 10,
  //     pageNumber: 0,
  //     startCount: 1,
  //     endCount: 10,
  //     next: true,
  //     prev: false,
  // }

  // updateState = (data: any) => {
  //     this.setState(data)
  // }





  render() {
    const {
      data = [],
      fetching,
      count,
      tableHeader,
      fetchNewData,
      client_code,
      type,
      history,
      pagination,
      activeTab,
      handleSendOpenItemEmail
    } = this.props;

    // const {
    //     activePage,
    //     limit,
    //     pageNumber,
    //     startCount,
    //     endCount,
    //     next,
    //     prev,
    // } = this.state;


    return (
      <>
        <Row className="align-items-center mb-3">
          <Col lg={8}>
            <AkPagination
              className={"mt-1 mb-1"}
              fetchData={fetchNewData}
              // updateState={this.updateState}
              count={count}
              limit={pagination?.limit}
              startCount={pagination?.startCount}
              endCount={pagination?.endCount}
              pageNumber={pagination?.pageNumber}
              next={pagination?.next}
              prev={pagination?.prev}
              updateState={this.props.updatePagination}

            />
          </Col>
          {/* <Col lg={4}>
            <span style={{ position: 'absolute', top: '8px', left: '25px' }}>
              <SearchIcon />
            </span>
            <input
              className="form-control"
              type="text"
              placeholder="Search Document (Min. 3 characters)"
              onChange={(e) => this.props.handleSearch(e)}
              style={{ paddingLeft: '35px' }}
            />
          </Col> */}


        </Row>
        {fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={5}
        />
          :
          <Row>
            <Col xs="12">
              <div className="table-bordered">
                <Table className="table table-striped">
                  <thead>
                    <TableHeader
                      tableHeader={tableHeader}
                    />
                  </thead>
                  <tbody>
                    <TableData
                      data={data}
                      tableHeader={tableHeader}
                      // deleteEntry={this.deleteEntry}
                      history={history}
                      activeTab={activeTab}
                      handleSendOpenItemEmail={handleSendOpenItemEmail}
                    />
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        }
      </>
    )

  }
}

export default SharedOpenItemsTable;